<template>
	<sup class="label-asterisk text-danger">*</sup>
</template>

<script>
	export default {
		name: 'FormAsterisk'
	}
</script>

<style type="text/scss" scoped>
	.label-asterisk {
		top: -.1em;
		font-size: 1em;
	}
</style>
